import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

import * as Common from 'common/components';

class FilePreviewRow extends PureComponent {
  static propTypes = {
    file: PropTypes.shape({
      status: PropTypes.string.isRequired,
      percentage: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    handleRemove: PropTypes.func.isRequired,
    id: PropTypes.any.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleRemove = (e) => {
    e.preventDefault();
    this.props.handleRemove(this.props.id);
  };

  state = { preview: null };

  render = () => (
    <tr>
      <td className="text-center align-middle">
        <Common.FilePreview file={this.props.file.file} />
      </td>
      <td className="align-middle">{this.props.file.name}</td>
      <td className="align-middle text-center">
        {this.props.t(this.props.file.status)}
        <div className="progress">
          <div
            className="progress-bar progress-bar-striped progress-bar-animated"
            style={{
              width: `${this.props.file.percentage}%`,
            }}
          />
        </div>
      </td>
      <td className="align-middle">
        {this.props.file.status === 'files.pending' && (
          <button className="btn btn-danger btn-sm" onClick={this.handleRemove}>
            {this.props.t('actions.delete')}
          </button>
        )}
      </td>
    </tr>
  );
}

export default translate()(FilePreviewRow);



// WEBPACK FOOTER //
// src/modules/common/components/files/FilePreviewRow.js